<!-- Boxen 2x2, darunter (nur in der eigenen Kachel) die Rangliste der Prüftypen, die die restliche
     Höhe nutzt.
     Aufbau, Größe und Abstände der Boxen sind identisch zu den Status-Boxen der Tasks-Kachel:
     2x2 nach Inhaltshöhe mit gap-3, nur die Icons tragen hier die Statusfarbe. -->
<div [class.h-full]="fillsHeight" class="flex flex-col gap-4 w-full min-h-0 overflow-hidden">
  <div [class.shrink-0]="fillsHeight" class="grid grid-cols-2 gap-3 w-full">
    <div [appSkeletonLoading]="loading" class="flex flex-row items-center gap-3 px-3 py-3 bg-gray-50 rounded-lg"
         tooltip="Prüfläufe der letzten 30 Tage" tooltipDirection="top">
      <div class="flex flex-row items-center gap-2 flex-1 min-w-0">
        <fa-icon [icon]="faClipboardList" class="text-sm text-gray shrink-0"></fa-icon>
        <span class="text-gray-900 text-sm font-medium truncate">Prüfläufe</span>
      </div>
      <span class="text-gray-900 text-lg font-medium shrink-0">{{ total }}</span>
    </div>

    <div [appSkeletonLoading]="loading" class="flex flex-row items-center gap-3 px-3 py-3 bg-gray-50 rounded-lg"
         tooltip="Abgeschlossene Prüfläufe der letzten 30 Tage" tooltipDirection="top">
      <div class="flex flex-row items-center gap-2 flex-1 min-w-0">
        <fa-icon [icon]="faCircleCheck" class="text-sm text-green shrink-0"></fa-icon>
        <span class="text-gray-900 text-sm font-medium truncate">Abgeschlossen</span>
      </div>
      <span class="text-gray-900 text-lg font-medium shrink-0">{{ completed }}</span>
    </div>

    <div [appSkeletonLoading]="loading" class="flex flex-row items-center gap-3 px-3 py-3 bg-gray-50 rounded-lg"
         tooltip="Laufende Prüfläufe" tooltipDirection="top">
      <div class="flex flex-row items-center gap-2 flex-1 min-w-0">
        <fa-icon [icon]="faSpinnerThird" class="text-sm text-yellow shrink-0"></fa-icon>
        <span class="text-gray-900 text-sm font-medium truncate">Läuft</span>
      </div>
      <span class="text-gray-900 text-lg font-medium shrink-0">{{ running }}</span>
    </div>

    <div [appSkeletonLoading]="loading" class="flex flex-row items-center gap-3 px-3 py-3 bg-gray-50 rounded-lg"
         tooltip="Fehlgeschlagene Prüfläufe der letzten 30 Tage" tooltipDirection="top">
      <div class="flex flex-row items-center gap-2 flex-1 min-w-0">
        <fa-icon [icon]="faCircleXmark" class="text-sm text-red shrink-0"></fa-icon>
        <span class="text-gray-900 text-sm font-medium truncate">Fehlgeschlagen</span>
      </div>
      <span class="text-gray-900 text-lg font-medium shrink-0">{{ failed }}</span>
    </div>
  </div>

  @if (fillsHeight) {
    <!-- Rangliste der Prüftypen: der Balken vergleicht mit dem häufigsten Typ, nicht mit der
         Gesamtzahl – so bleibt der Abstand zwischen den Typen lesbar. -->
    <div class="flex flex-col gap-2 flex-1 min-h-0 overflow-hidden">
      <span class="text-gray-900 text-sm font-medium" tooltip="Ausgeführte Prüfläufe der letzten 30 Tage nach Prüftyp"
            tooltipDirection="top">Häufigste Prüftypen</span>
      @if (topCheckTypes.length > 0) {
        <div class="flex flex-col gap-3 flex-1 overflow-y-auto overflow-x-hidden">
          @for (type of topCheckTypes; track type.label) {
            <div class="flex flex-col gap-1">
              <div class="flex flex-row items-baseline gap-3">
                <span [title]="type.label"
                      class="text-gray-900 text-sm font-normal truncate flex-1">{{ type.label }}</span>
                <span class="text-gray-500 text-xs font-normal shrink-0">{{ runLabel(type.count) }}</span>
              </div>
              <div class="h-1.5 w-full bg-gray-100 rounded-full overflow-hidden">
                <div [style.width.%]="type.percent" class="h-full bg-blue-500 rounded-full"></div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div [appSkeletonLoading]="loading" class="flex flex-1 rounded-lg">
          <span class="text-gray-500 text-sm font-normal">In den letzten 30 Tagen wurde nichts geprüft.</span>
        </div>
      }
    </div>
  }
</div>
